import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { Curso } from '../../interfaces/curso';
import { CursosService } from '../../services/cursos.service';
import { SessionService } from '../../services/session.service';
import { animations } from '../../tools/animations';

@Component({
  selector: 'app-curso-detalle',
  templateUrl: './curso-detalle.component.html',
  styleUrls: ['./curso-detalle.component.css'],
  animations: animations
})
export class CursoDetalleComponent implements OnInit {

  public curso_id;
  public curso: Curso;
  public cursosGratuitos: Curso[];
  public initializing: boolean = true;
  public codigoAcceso: string = null;
  public mensajeCodigo: string = '';
  public codigoValido: boolean = false;
  public validating: boolean = false;
  public version: number;

  constructor(
    private cursosService: CursosService,
    private route: ActivatedRoute,
    public sessionService: SessionService,
    private erroresHandler: ErroresHandler
  ) { 
    this.cursosService.getCursosGratuitos().then( ( _data: Curso[] ) => {
      this.cursosGratuitos = _data;
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pueden cargar los cursos gratuitos',
          'Error'
      );
    });
  }

  keyPressAlphanumeric(event) {
    this.mensajeCodigo = '';
    if (/[a-zA-Z0-9]/.test(String.fromCharCode(event.keyCode))) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  validarCodigoAcceso(){
    this.validating = true;
    this.cursosService.validarCodigoAcceso({ curso_id: this.curso_id, version: this.version, codigoAcceso: this.codigoAcceso}).then(_data => {
      this.codigoValido = _data;
      this.codigoValido ? this.mensajeCodigo = 'Ya puedes postular a este curso.': this.mensajeCodigo = 'El código ingresado no es válido, intentelo nuevamente.';
      this.validating = false;
    });
  } 

  ngOnInit(): void {
    this.route.queryParams.forEach(params => {
      this.curso_id = params.curso_id;
      this.version = params.version;
      this.cursosService.getCursoPorIdVersion({ curso_id: params.curso_id, version: params.version }).then((_data: Curso) => {
        this.curso = _data;
        this.curso.fechaTermino = (new Date(this.curso.fechaInicio).getTime() == new Date(this.curso.fechaTermino).getTime()) ? null : this.curso.fechaTermino;
        this.initializing = false;
      }).catch(e => {
        this.erroresHandler.processError(
            e,
            'alert',
            'No se pudo cargar la información del curso, intente nuevamente',
            'Error'
        );
      });


      this.codigoAcceso = params.codigoAcceso;
      if( this.codigoAcceso ){
        this.validarCodigoAcceso();
      }


    });

  }

}
